import * as Base from '@base';
import { Box, useTranslation } from '@common';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { ModalFooterProps } from './types';

export function ModalFooter(props: ModalFooterProps): ReactElement {
  const [t] = useTranslation();
  return (
    <Box className={styles.modalFooter}>
      <Box>
        <Base.Button autoInsertSpace={false} onClick={props.onCancel}>{t('取消')}</Base.Button>
        <Base.Button className={styles.ml5} type='primary' autoInsertSpace={false} onClick={props.onOk}>{t('确定')}</Base.Button>
      </Box>
    </Box>
  );
}
